import {combineReducers} from 'redux';

import {default as invoicesReducer} from './invoices';
import {default as revenueReducer} from './revenue';
import {default as lookerRevenueReducer} from './lookerRevenue';

export const RENT_VERBOSE = 'Rent';
export const DEPOSIT_VERBOSE = 'Deposit';
export const ONE_OFF_CHARGE_VERBOSE = 'One off charges';

export const RENT_KEY_FOR_API = 'RENT';
export const DEPOSIT_KEY_FOR_API = 'DEPOSIT';
export const ONE_OFF_CHARGE_KEY_FOR_API = 'ONE_OFF_CHARGE';

export const SCHEDULE_TYPES_FOR_VISUALIZATION = {
  [RENT_KEY_FOR_API]: RENT_VERBOSE,
  [DEPOSIT_KEY_FOR_API]: DEPOSIT_VERBOSE,
  [ONE_OFF_CHARGE_KEY_FOR_API]: ONE_OFF_CHARGE_VERBOSE
};

export const INVOICE_STATUSES = {
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID: 'PAID',
  VOID: 'VOID',
  UPCOMING: 'UPCOMING',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  OVERDUE: 'OVERDUE',
  FULLY_CREDIT: 'FULLY_CREDIT'
};

export const INVOICE_STATUS_MAPPER_FOR_FILTERS = [
  {label: 'Upcoming', value: INVOICE_STATUSES.UPCOMING},
  {label: 'Paid', value: INVOICE_STATUSES.PAID},
  {label: 'Overdue', value: INVOICE_STATUSES.OVERDUE},
  {label: 'Void', value: INVOICE_STATUSES.VOID},
  {label: 'Partially paid', value: INVOICE_STATUSES.PARTIALLY_PAID},
  {
    label: 'Payment pending',
    value: INVOICE_STATUSES.PAYMENT_PENDING
  },
  {label: 'Payment failed', value: INVOICE_STATUSES.PAYMENT_FAILED},
  {label: 'Fully credit', value: INVOICE_STATUSES.FULLY_CREDIT}
];

export const CREDIT_NOTE_STATUSES = {
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  PAID: 'PAID',
  VOID: 'VOID',
  UPCOMING: 'UPCOMING'
};

export const XERO_STATUSES = {
  SYNCED: 'SYNCED',
  NOT_SYNCED: 'NOT_SYNCED',
  FAILED: 'FAILED'
};

export const BEFORE_CUT_OFF_DATE_KEY_FOR_API = 'BEFORE_CUT_OFF_DATE';

const reducer = combineReducers({
  invoices: invoicesReducer,
  revenue: revenueReducer,
  looker: lookerRevenueReducer
});

export default reducer;
export * from './invoices';
export * from './revenue';
export * from './lookerRevenue';
